module.exports = __webpack_public_path__ + "img/library.aed571b2.svg";